import React from "react"
import Layout from "../../components/layout"
import LayoutNieuwsbrief from "../../components/layoutnieuwsbrief"
import Image1 from "../../images/nieuwsbrieffeb2020/Picture1.jpg"
import Image2 from "../../images/nieuwsbrieffeb2020/Picture2.png"
import Image3 from "../../images/nieuwsbrieffeb2020/Picture3.png"
import Image4 from "../../images/nieuwsbrieffeb2020/Picture4.png"
import Image5 from "../../images/nieuwsbrieffeb2020/Picture5.png"
import Image6 from "../../images/nieuwsbrieffeb2020/Picture6.png"
import Image7 from "../../images/nieuwsbrieffeb2020/Picture7.png"
import Image8 from "../../images/nieuwsbrieffeb2020/Picture8.jpg"
import Image9 from "../../images/nieuwsbrieffeb2020/Picture9.jpg"
import Image10 from "../../images/nieuwsbrieffeb2020/Picture10.jpg"
import Image11 from "../../images/nieuwsbrieffeb2020/Picture11.jpg"

import { Financieel2019, Financieel2019India } from "../../components/financieel2019"

import { Image, ImageBottom } from "../../components/imagecomponents"
import { Ondertekening } from "../../components/snippets.js"
import Seo from "../../components/seo"

const Nieuwsbrief = () => (
  <Layout>
    <Seo title="Jaarverslag 2019" />

    <LayoutNieuwsbrief>
      <h2>Jaarverslag 2019</h2>

      <h3>Examens, geslaagd in 2019</h3>
      <p>
        In 2019 behaalden 7 studenten van Dr. T.S. Wilkinson High School en Junior College het diploma Junior College en
        4 studenten het diploma High School.
        <br />
        Voor twee serieuze kinderen die echt tot de allerarmsten behoren hebben we besloten de vervolgopleiding te
        betalen. Zij zijn beiden in augustus gestart. Voor beide kinderen hebben we een sponsor gevonden.
        <br />
        Anil Jadhav, een kind zonder moeder, wiens vader een dronken voddenraper is, kwam bij ons toen hij 3 jaar was.
        Voor hem hebben we een sponsor uit India gevonden. Anil scoorde 86,77% in klas 12 met alleen lessen op school en
        geen extra lessen. Dat is echt heel hoog. Anil doet nu de opleiding BCCA, een 3-jarige opleiding bachelor in
        Commerce and Computer Application op een prestigieuze priv&eacute;school. In de eerste examentermijn werd hij
        tweede tussen 93 studenten van rijke afkomst. Anil woont in het hostel en gaat elke dag met de bus op en neer.
        Als hij terug komt studeert hij achter de computer. Bekijkt u onze nieuwe videofilm van oktober 2019 eens op
        onze website. Anil staat centraal in deze video. De video is ook te zien op{" "}
        <a href=" https://www.youtube.com/watch?v=IxKkqk-yO3A&t=2s">YouTube</a>
      </p>
      <p>
        Saloni Dhurve is de tweede leerling die een goede opleiding krijgt. Zij wordt gesponsord door mijzelf. Saloni
        doet de 3-jarige opleiding tot verpleegkundige in het Mure Memorial hospital.
      </p>
      <p>
        Na dit schooljaar zijn er weer een aantal zeer arme kinderen die graag een opleiding willen gaan volgen. In
        ieder geval 3 kinderen en misschien nog een meer. Isha Dhurve en Simran Shrivas willen ook de opleiding tot
        verpleegkundige in het Mume Memorial hospital gaan doen, een 3-jarige opleiding, kosten 1.550 euro per jaar en
        Yash Khobragade de Tango Charlie Army, Police Career Academy, een 1-jarige vooropleiding om toegelaten te worden
        tot leger, politie etc. (kosten 662 euro voor een jaar). Voor hen zoeken we nog sponsors. Wellicht dat u
        overweegt sponsor te worden van &eacute;&eacute;n van deze 3 studenten. Misschien kunt u het samen met een of
        meer familieleden of vrienden doen. We gaan in ieder geval ook proberen of ze in aanmerking kunnen komen voor
        een studiebeurs van een van de Nederlandse fondsen.
      </p>

      <ImageBottom src={Image1} tekst="Anil (rechts) met zijn broer Sunil (links)" />
      <br />

      <h3>Een overzicht van de donateurs van stichting Nav-Jeevan in 2019 </h3>
      <p>
        <i>(zie ook het financieel overzicht 2019 op deze website)</i>
      </p>
      <p>
        <b>Vaste donateurs</b>
        <br />
        Stichting Nav-Jeevan heeft een flink aantal vaste donateurs die maandelijks een bedrag doneren. Het gaat om
        familieleden, vrienden en kennissen van de bestuursleden en medewerkers van de Calder Holding.
      </p>

      <p>
        <br />
        <b>Calder Holding trouwe sponsor vanaf 2003</b>
        <br />
        Vanaf het begin verdubbelt de Calder Holding elke euro die haar personeel schenkt. Wij zijn erg blij met deze
        trouwe sponsor.
      </p>
      <Image src={Image2} />
      <p>
        <i>
          Bij de bedrijven in Calder Holding staat de mens centraal. Zij werken voor en met mensen. Van Inactief naar
          Actief is hun motto. Hun visie is dat mensen van betekenis willen zijn en dat participeren (meedoen) in de
          maatschappij daarvoor het beste middel is. Samen met hun 900 enthousiaste medewerkers helpen ze dagelijks vele
          honderden cliënten verder in Onderwijs, Zorg of Werk.
        </i>
      </p>

      <p>
        <br />
        <b>Stichting Belangenbehartiging voor het (zeer) Jonge Kind.</b>
        <br />
        Stichting Nav-Jeevan ontvangt sinds 2013 jaarlijks een bijdrage van de Stichting Belangenbehartiging voor het
        (zeer) Jonge Kind. Zo ontvingen wij in 2019 wederom een bijdrage van 15.000 euro voor voeding, uniformen etc.
        Ook voor 2020 hebben zij weer een bedrag van 15.000 euro toegekend.
      </p>
      <br />

      <p>
        Van <b>de Heutink foundation</b> ontvingen we een bedrag van 1.080 euro voor het salaris voor een jaar van Dolly
        Nandeshwar. Zij verzorgt op zaterdag en zondag danslessen.
      </p>
      <Image src={Image3} />
      <p>
        <i>Hun motto: Ieder kind verdient een kans om te schijnen!</i>
      </p>

      <p>
        <br />
        Uit de opbrengst van de Derde Wereld Rommelmarkt van het <b>Mill Hill College</b> kregen we 5.500 euro voor de
        aanschaf van bankjes met tafeltjes, docententafels, voorraadkasten en een elektronische waterconditioner.
      </p>
      <Image src={Image4} />
      <p>
        <i>
          De verbondenheid met de derde wereld komt voort uit hun geschiedenis. Vroeger was het Mill-Hill van de
          kloosterorde ‘The fathers of Mill Hill’. Deze monniken werden opgeleid om te werken in derdewereldlanden. Nog
          steeds voelen zij zich verbonden met mensen in de derde wereld en willen dit actief uitdragen.
        </i>
      </p>
      <p>
        <br />
        Van <b>AFAS</b> kregen we de toezegging van 70.000 euro voor de bouw van een hostel. Dit geld komt in 2020 ter
        beschikking zodra we grond gevonden hebben en gestart zijn met de bouw.
        <br />
        <br />
        <Image src={Image5} />
        <br />
        <i>
          De AFAS Foundation inspireert en doet. Het inspireert jou om beter te doen. Daar waar jij kansen ziet om het
          beter te doen dan nu gebeurt. Altijd met grote gevolgen. Omdat het heel veel mensen helpt. Of juist omdat het
          heel veel mensen inspireert om te veranderen.
        </i>
      </p>
      <p>
        <br />
        We hebben ook een toezegging gekregen van de boekenbeurs van de <b>Vincentiusvereniging Den Bosch</b> voor de
        inrichting van een gymzaal/fitness ruimte. Deze bijdrage wordt eind maart verwacht.
        <br />
        <br />
        <Image src={Image6} />
        <br />
        <i>
          De Vincentiusvereniging ’s-Hertogenbosch biedt directe en persoonlijke hulp aan gezinnen en alleenstaanden die
          in armoede leven of daarin dreigen terecht te komen.
        </i>
      </p>
      <p>
        Door een particuliere gift konden we in 2019 ook een tweede grote schoolbus kopen. Dit was hard nodig omdat de
        kinderen uit verschillende delen van Nagpur komen.
      </p>
      <p>
        Tot slot zijn we uitgekozen voor het koffiedoos project van de{" "}
        <b>Protestantse Gemeente Samen op weg Berlicum-Rosmalen</b>. Vanaf oktober 2019 staat er elke zondag een
        collectebus in de kerk. De opbrengst is voor Nav-Jeevan. De bijdrage wordt in 2020 verwacht.
      </p>
      <br />

      <Image src={Image7} />
      <br />
      <br />

      <Financieel2019 />

      <p>
        Wij zijn trots te kunnen zeggen dat 100% van de door Stichting Nav-Jeevan ontvangen donaties naar Nav-Jeevan
        Sanstha in India gaat.
      </p>
      <br />

      <Financieel2019India />

      <br />
      <Image src={Image8} />
      <br />

      <h3>Zorgen voor de toekomst</h3>

      <p>
        Aan het begin van het schooljaar 2019-2020 hadden we bijna 500 kinderen op school. Meer dan 200 van hen
        verblijven in het hostel. We maken ons wel wat zorgen over de toekomst.
        <br />
        We waren erg blij met het tribal project dat in 2015 startte. En ook Tech Mahindra startte met sponseren. Dit
        betekende dat Nav Jeevan Sanstha niet langer alleen afhankelijk was van donaties uit Nederland. Helaas brengt
        Tech Mahindra haar donatie het komend jaar terug van ongeveer 37.000 naar ongeveer 22.000 euro. Zij zullen geen
        bijdrage meer leveren aan de salarissen met uitzondering van de projectco&ouml;rdinator, de sportleraar en de
        computerdocent. De rest blijven zij wel sponsoren. Dit gaat in per 1-4-2020.
      </p>
      <p>Verder zijn er nogal wat openstaande rekeningen.</p>
      <p>
        Stichting Nav-Jeevan ontvangt sinds 2013 jaarlijks een bijdrage van de Stichting Belangenbehartiging voor het
        (zeer) Jonge Kind. Zo ontvingen wij in 2019 wederom een bijdrage van 15.000 euro voor voeding, uniformen etc.
        Ook voor 2020 hebben zij weer een bedrag van 15.000 euro toegekend. Dit wordt het laatste jaar omdat zij ermee
        stoppen. Dit is erg jammer omdat het een van de weinige fondsen is die een bijdrage geven voor voeding. De
        doelen moeten vrijwel altijd concrete projecten zijn. We zullen een speciale werving moeten opzetten om dit gat
        te dichten.
      </p>
      <p>
        Gelukkig gaan Kiran en Roger Wingelaar zich ook weer inzetten om sponsors in de Verenigde Staten te werven.
        <br />
        Daarnaast hebben Iris Wilkinson en Aneeta Patel ook een aantal betalende kinderen toegelaten.
      </p>
      <p>Wij gaan er met zijn allen voor Nav-Jeevan een gezonde instelling te laten blijven.</p>

      <h3>Wat u kunt doen om ons te helpen.</h3>
      <ul>
        <li>
          Brengt u het project onder aandacht van uw familie, vrienden en kennissen en vraag hen donateur te worden.
        </li>
        <li>
          Benader de school van uw kind of een bedrijf dat u kent en vraag hen een bijdrage te leveren. Natuurlijk komen
          wij graag langs om voorlichting te geven.
        </li>
        <li>
          Kent u iemand die binnenkort een jubileum heeft vraagt u hem/haar dan eens om in plaats van cadeaus een
          donatie aan Nav Jeevan te vragen. Of wellicht bent u zelf binnenkort jarig en denkt u eraan hetzelfde te doen.
          Als u voor deze gelegenheid een leuke collectebus met Picture&#39;s van Nav-Jeevan nodig hebben laat het ons
          dan even weten.
        </li>
        <li>
          En dan wil ik u er nog op wijzen hoe u op een eenvoudige wijze, zonder dat het u iets kost, kunt zorgen dat er
          extra geld binnenkomt voor Nav-Jeevan. Nav-Jeevan heeft zich namelijk aangesloten bij Sponsor kliks. Koopt u
          wel eens online? Ga dan eerst naar onze website en klik rechtsboven in de hoek op het logo van Sponsorkliks.
          Klik vervolgens op de balk en je komt uit bij ruim 300 winkels waar je precies hetzelfde betaalt maar er gaat
          een commissie naar Nav-Jeevan. Je sponsort ons dus gratis door eerst op de balk te klikken, dan je winkel te
          kiezen en je bestelling te plaatsen! Het gaat hier niet alleen om webwinkels als bol.com maar ook als u
          bijvoorbeeld uw reis boekt via booking.com of KLM ontvangt Stichting Nav-Jeevan een commissie. Je kunt ook
          rechtstreeks naar de website van Sponsorkliks, www.sponsorkliks.com, gaan maar vergeet dan niet eerst in de
          bovenste balk Stichting Nav-Jeevan in te vullen. Je ziet nadat je je bestelling geplaatst hebt niet dat er een
          commissie naar Stichting Nav-Jeevan gaat maar het gebeurt wel.
        </li>
      </ul>

      <Image src={Image9} />

      <br />

      <h3>Bestuur 2019</h3>
      <p>
        Het bestuur van Nav-Jeevan is in 2019 uitgebreid met twee nieuwe leden: Miriam van der Sloot en Hans van der
        Sloot.
        <br />
        Cees van der Flier stopt ermee. Hij is vanaf de start in 2003 penningmeester geweest. Wij danken hem hartelijk
        voor zijn inzet in de afgelopen 17 jaar.
      </p>
      <p>De nieuwe verdeling van de bestuursfuncties ziet er als volgt uit:</p>

      <ul className="ulminus" style={{ marginLeft: "1em", marginBottom: "0.4em" }}>
        <li>Aura Laumen, voorzitter (was voorheen secretaris)</li>
        <li>Miriam van der Sloot, secretaris (nieuw)</li>
        <li>Annelies van de Ven, penningmeester (was voorheen voorzitter)</li>
        <li>Tom Verhoeven, website</li>
        <li>Hans van der Sloot, werving scholen en bedrijven</li>
      </ul>
      <p>Vrijwilliger: Swatee Span, voorlichting</p>
      <br />
      <p>
        In onze vorige nieuwsbrief gaven we aan dat we de nieuwsbrief voortaan per e-mail willen versturen. Veel
        donateurs hebben inmiddels hun e-mail adres doorgegeven. Mocht u dit nog niet gedaan hebben zou u dit alsnog
        willen doen naar <a href="mailto:avandeven@home.nl">avandeven@home.nl</a> of{" "}
        <a href="mailto:nav-jeevan@home.nl">nav-jeevan@home.nl</a>. Voor het Calder personeel bij voorkeur uw privé
        emailadres. En hebt u een partner of kinderen die ook graag op de hoogte worden gehouden geef dan ook hun
        emailadres door.
        <br />
        Mocht u de nieuwsbrief in de toekomst liever op papier blijven ontvangen laat het me dan ook even weten.
      </p>

      <p>We sluiten af met een bericht van de directeur van de school Vicky Simon (foto onder)</p>

      <br />

      <Image src={Image10} />

      <br />

      <h3>Mijn reis met Navjeevan</h3>

      <p>&quot;De tijd lijkt te vliegen, hij reist nooit sneller dan &eacute;&eacute;n dag tegelijk&quot;"</p>

      <p>
        Dus hier is mijn reis van 4380 dagen op Dr. T. Wilkinson Memorial High School en Junior College Godhni, gerund
        door Navjeevan Sanstha. Hartelijk dank voor het kiezen van mij om deze speciale instelling te leiden, omdat mijn
        12 jaar dienst in alle aspecten bijzonder bleek te zijn, van het overbruggen van de kloof tussen de opgeleide en
        de ongeschoolde, de geletterde en de ongeletterde, de bevoorrechte en de kansarme, de machtigen en de zwakken,
        wat een enorme impact heeft op het verbeteren van het leven van de kinderen, beter, intelligenter en mooier.
      </p>

      <p>
        Ik begin met het bedanken van de donors die het leven van Navjeevan hebben behouden door het al die jaren
        planten van zaden om in prachtige bloemen te bloeien. Moge God u allen zegenen om dit zo lang mogelijk te
        blijven doen. Jullie maken allemaal deel uit van Navjeevan en zullen dat altijd blijven.
      </p>

      <p>
        Mijn verbinding met Navjeevan begon in november 2008. Mijn reis tot op heden was opwindend en een bundel van
        vreugde toen het groeide van ongeveer 50 studenten tot 466. Dit was niet alleen gedenkwaardig, maar ook een
        uitdagende taak. Met een gezamenlijke inspanning in combinatie met slimme mensen met een visie zoals de trouwe
        mevrouw Iris Wilkinson en mevrouw Aneeta Patel ging de school stap voor stap langzaam maar zeker vooruit.
      </p>

      <p>
        Het was tijdens mijn tijd dat het voorstel voor schoolerkenning door de overheid werd ingediend en na een paar
        jaar, in het jaar 2013, ontvingen we die erkenning. Dit was een gigantische taak maar met de hulp van mevrouw
        Aneeta Patel waren we in staat om te slagen en de school transformeerde van een alfabetiseringsproject naar een
        volwaardige school. Het was een genot om onze studenten voor onze school te zien uitkomen, eerder moest ik
        toestemming van St. Ursula School en St. Michael School krijgen om deel te nemen aan hun staatsexamens zodat ze
        geen jaar verspilden. In 2015 kregen we toestemming om Junior College te starten in de 3 stromen - Arts, Science
        en Commerce - en in twee talen, Hindi en Engels. Het werd de enige tweetalige school in Godhni.
      </p>

      <p>
        In mijn ambtstermijn heb ik de school zien veranderen - 100% resultaten in het high school examen, de toevoeging
        van tribal kinderen, de science labs, de bibliotheek, meer klaslokalen etc. De school is ook vooruitgegaan en
        blonk uit in resultaten, sport en culturele activiteiten en is elke keer geprezen voor zijn uitstekende
        prestaties. Wetenschapstentoonstellingen, geschiedenis- en aardrijkskundepresentatie en nog veel meer werden
        jaarlijks georganiseerd.
      </p>

      <p>
        &quot;All work and no play, makes Jack a dull boy&quot;. We organiseren elk jaar op 14 november Bal Mela op de
        verjaardag van de eerste premier Pandit Jawaharlal Nehru, gevierd in India als kinderdag. Bal Mela betekent
        kindercarnaval voor een dag vol plezier en ook fondsenwerving voor de school.
      </p>

      <p>
        Dit alles was een succes en mijn opdracht om de school op hetzelfde niveau te brengen als andere scholen is
        geslaagd.
      </p>

      <p>
        Ik dank iedereen voor het vertrouwen dat ze in mij hebben gesteld en voor het naar grote tevreden maken van mijn
        reis van 2008 tot 2020. Het is een zegen om de school in sprongen vooruit te zien gaan, ik bid oprecht dat de
        school het hoogtepunt van glorie zal bereiken.
      </p>

      <p>
        Last but not least, mijn oprechte dankbaarheid aan de goedhartige, liefdevolle en nederige Annelies en Tom die
        de zaken soepel en eerlijk hebben laten verlopen en sterk waren in tijden van nood. Ze kwamen altijd met
        projecten die gunstig zijn voor de school en zorgden dat het werd uitgevoerd. Hun grote interesse, hun
        samenwerking en hun liefde hebben de school in warme en gezonde zonneschijn gehouden. Niets kan alleen worden
        gedaan, het zijn de verenigde inspanningen van al diegenen die direct of indirect verbonden zijn met de school,
        en de resultaten zijn te zien ...
      </p>

      <p>
        Dit alles zou niet kunnen worden gedaan zonder de vriendelijke, liefdevolle handen van de Almachtige die ons
        hebben geleid en ons het pad van gerechtigheid en vreugde hebben getoond.
      </p>

      <p>
        Ik ben gezegend en vereerd om op een school te zijn waar ik de mensheid kan helpen en waar ik het in een positie
        kon brengen waar het trots op kan zijn ​​en zijn kinderen in het perfecte licht voor kennis en begrip kan zien
        bloeien en weggaan - &quot;Van duisternis naar licht&quot;.
      </p>

      <p>
        <big>&nbsp;&nbsp;&nbsp;Mijn reis hier eindigt ...</big>
      </p>

      <p>
        <big>&nbsp;&nbsp;&nbsp;Vicky Simon (Directeur) Dr. Wilkenson School</big>
      </p>
      <br />

      <p>
        Na deze mooie woorden van Vicky wil ik u namens de kinderen en de medewerkers van Nav Jeevan hartelijk danken
        voor uw donaties.
      </p>

      <Image src={Image11} />
      <br />

      <Ondertekening />
    </LayoutNieuwsbrief>
  </Layout>
)

export default Nieuwsbrief
